import {
  FormControl,
  Select,
  SelectChangeEvent,
  SxProps,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {
  label: string;
  value: string | undefined;
  onChange: (event: SelectChangeEvent) => void;
  colorScheme?: 'light' | 'dark';
  items: JSX.Element[];
  sx?: SxProps;
};

const Dropdown: React.FC<Props> = ({
  value,
  onChange,
  colorScheme,
  label,
  items,
  sx,
}) => {
  const theme = useTheme();

  return (
    <FormControl sx={{ ...sx }}>
      <Select
        value={value}
        label={label}
        onChange={onChange}
        displayEmpty
        IconComponent={ExpandMoreIcon}
        inputProps={{
          MenuProps: {
            MenuListProps: {
              sx: {
                backgroundColor:
                  colorScheme === 'dark'
                    ? theme.colors.common.softBlack
                    : theme.colors.common.white,
                color:
                  colorScheme === 'dark'
                    ? theme.colors.common.white
                    : theme.colors.common.black,
              },
            },
          },
        }}
        sx={{
          width: '100%',
          fontSize: '1rem',
          color:
            colorScheme === 'dark'
              ? theme.colors.common.white
              : theme.colors.common.softBlack,
          '& .MuiSelect-select': { p: 0 },
          '& .MuiSelect-icon': {
            color:
              colorScheme === 'dark'
                ? theme.colors.common.white
                : theme.colors.common.softBlack,
          },
          '& .MuiMenu-paper': {
            color: 'black',
          },
        }}
      >
        {items}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
